export const OPPORTUNITY_OUTCOME = {
  OPEN: 'open',
  WON: 'won',
  LOST: 'lost',
} as const

export type OpportunityOutcome =
  (typeof OPPORTUNITY_OUTCOME)[keyof typeof OPPORTUNITY_OUTCOME]

export interface OpportunityFunnelStage {
  id: number
  name: string
  description: string
  outcome: OpportunityOutcome
  finishConversation: boolean
  position: number
}

export const OPPORTUNITY_MAX_ITEMS = 100
export const OPPORTUNITY_MAX_QUANTITY = 1_000_000
export const OPPORTUNITY_QUANTITY_STEP = 0.001

export const OPPORTUNITY_DASHBOARD_VIEW = {
  ...OPPORTUNITY_OUTCOME,
  UNASSIGNED: 'unassigned',
  STALE: 'stale',
  STAGE: 'stage',
} as const

export const OPPORTUNITY_DASHBOARD_FILTERS_KEY = 'filters-panel-expanded:opportunity-dashboard'
export const OPPORTUNITY_KANBAN_FILTERS_KEY = 'filters-panel-expanded:opportunity-kanban'

export const OPPORTUNITY_FILTER_ALL = 'all'
export const OPPORTUNITY_FILTER_UNASSIGNED = 'unassigned'
export const OPPORTUNITY_VALUE_FILTER = {
  ALL: OPPORTUNITY_FILTER_ALL,
  INFORMED: 'informed',
  MISSING: 'missing',
} as const
export const OPPORTUNITY_OUTCOME_LABELS = {
  [OPPORTUNITY_OUTCOME.OPEN]: 'Abertas',
  [OPPORTUNITY_OUTCOME.WON]: 'Ganhas',
  [OPPORTUNITY_OUTCOME.LOST]: 'Perdidas',
}
export const OPPORTUNITY_VALUE_FILTER_LABELS = {
  [OPPORTUNITY_VALUE_FILTER.ALL]: 'Todos',
  [OPPORTUNITY_VALUE_FILTER.INFORMED]: 'Com valor informado',
  [OPPORTUNITY_VALUE_FILTER.MISSING]: 'Sem valor informado',
}

export const OPPORTUNITY_ARCHIVED_FILTERS_KEY = 'filters-panel-expanded:opportunities-archived'
